import React from "react";
import { withRouter } from "react-router";

class ResetPassword extends React.Component {

  render() {
    return (
      <>
        <div className="g-flex-row">
          <div className="lui-text-content-area">
            <p>This page is for user to reset password when first login.</p>
          </div>
        </div>
      </>
    );
  }
}

export default withRouter(ResetPassword);
